import {forBrands, styled} from '@core-ui/react-stitch';

const getColor = ({theme}) => forBrands(theme, {
  at: t => t.color.b1,
  br: t => t.color.bk,
  brfs: t => t.color.bk,
  gap: t => t.color.b1,
  gapfs: t => t.color.b1,
  on: t => t.color.b1,
});

const ToggleButton = styled.button(({theme}) => ({
  ...theme.brandFont,
  appearance: 'none',
  backgroundColor: 'white',
  borderRadius: 0,
  border: 'none',
  fontSize: '.9rem',
  textAlign: 'center',
  textTransform: 'capitalize',
  width: '100%',
  zIndex: 1,
  outline: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'sticky',
  bottom: 0,
  left: 0,
  height: '2.5rem',
  color: getColor({theme}),
}));

export default ToggleButton;
